import { el, setChildren, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

class FilePreview {

  constructor() {

    this.spinner = el('img', {
      class: 'spinner',
      src: 'https://shared-assets.venturz.co/images/spinner.svg'
    });
    this.content = el('img', {
      class: 'file-preview-content',
      src: 'https://shared-assets.venturz.co/images/upload-picture-indicator.svg'
    });
    this.contentContainer = el('.file-preview-content-container', this.content);

    this.el = el('.file-preview-main', this.contentContainer);

  }

  getContent(file) {

    const url = this.getFileURL(file);

    const mimetype = file.mimetype;

    if (mimetype.indexOf('video/') !== -1) {
      return el('video', {
        class: 'file-preview-content',
        src: url
      });
    }

    if (mimetype.indexOf('audio/') !== -1) {
      return el('audio', {
        class: 'file-preview-content',
        src: url
      });
    }

    return el('img', {
      class: 'file-preview-content',
      src: url
    });

  }

  getFileURL(file) {

    const mimetype = file.mimetype;

    if (mimetype.indexOf('image/') !== -1) {
      return file.url;
    }

    if (mimetype.indexOf('video/') !== -1) {
      return file.url;
    }

    if (mimetype.indexOf('audio/') !== -1) {
      return file.url;
    }

    if (mimetype === 'application/pdf') {
      return '/images/pdf-file-icon.svg';
    }

    if (mimetype === 'text/csv') {
      return '/images/csv-file-icon.svg';
    }

    if (mimetype === 'text/plain') {
      return '/images/text-file-icon.svg';
    }

    const wordFileTypes = [
      'application/msword',
      'application/vnd.openxmlformats',
      'officedocument.wordprocessingml.document'
    ];

    if (wordFileTypes.indexOf(mimetype) !== -1) {
      return '/images/word-file-icon.svg';
    }

    return '/images/text-file-icon.svg';

  }

  displayFile(file) {

    this.content = this.getContent(file);

    setChildren(this.contentContainer, [this.content]);
  }

  setIdle() {
    setChildren(this.el, [this.contentContainer]);
  }

  setWorking() {
    setChildren(this.el, [this.spinner]);
  }

  reset() {
    setAttr(this.content, {
      src: '/images/upload-picture-indicator.svg'
    });
  }

}

export default FilePreview;